import React, { useState, useEffect } from 'react';
import { InputLabel, MenuItem, FormControl } from '@material-ui/core';

import Select from 'react-select';

import useStyles from './styles';

//TODO : lineaSelected  en reginales no contiene el id de la linea sino el del ramal

export default ({
  estacionesGet,
  lineaSelected,
  fieldSelected,
  setDataSearchServicio,
  sentido,
  nameField,
  estacionOrigen,
}) => {
  const classes = useStyles();

  const [estaciones, setEstaciones] = useState([
    { value: 0, label: '- Seleccioná la estación -' },
  ]);

  useEffect(() => {
    if (estacionesGet) {
      const estacionesfiltradas = estacionesGet.filter(
        (e) => e.ramal_id === lineaSelected
      );

      if (estacionesfiltradas.length) {
        const efe = estacionesfiltradas[0].estaciones;

        const optionFormat = efe.map((estacion, index) => {
          return {
            value: estacion.id,
            label: estacion.nombre,
          };
        });

        setEstaciones(optionFormat);
      }
    }
  }, [lineaSelected]);

  useEffect(() => {
    if (estacionesGet) {
      const estacionesfiltradas = estacionesGet.filter(
        (e) => e.ramal_id === lineaSelected
      );

      if (estacionesfiltradas.length) {
        const efe = estacionesfiltradas[0].estaciones;

        const indexEstacionOrigen = efe.filter((e) => e.id != estacionOrigen);

        const optionFormat = indexEstacionOrigen.map((currentValue, index) => {
          return { value: currentValue.id, label: currentValue.nombre };
        });

        setEstaciones(optionFormat);
      }
    }
  }, [estacionOrigen]);

  const onSelectEstacion = (e) => {
    const r = { target: { name: nameField, value: e.value } };
    setDataSearchServicio(r);
  };

  return (
    <FormControl variant='outlined' className={classes.formControl}>
      <div>
        {/* <InputLabel id='selected-estacion-label'></InputLabel> */}
        <label for='selected-estacion-label'>{sentido}</label>
      </div>
      <div>
        <Select
          options={estaciones}
          placeholder={'- Seleccioná la estación -'}
          onChange={onSelectEstacion}
          name={nameField}
        />
      </div>
    </FormControl>
  );
};
